var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1618_290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.3334C12.5001 16.7538 12.3413 17.1588 12.0554 17.4671C11.7695 17.7755 11.3776 17.9643 10.9583 17.9959L10.8333 18H9.16666C8.74618 18.0002 8.34119 17.8413 8.03287 17.5554C7.72455 17.2695 7.5357 16.8776 7.50416 16.4584L7.5 16.3334H12.5ZM10 2.16669C11.5125 2.16666 12.9658 2.7541 14.0535 3.80508C15.1412 4.85607 15.7781 6.28843 15.83 7.80002L15.8333 8.00002V11.1367L17.3517 14.1734C17.4179 14.3059 17.4511 14.4524 17.4483 14.6006C17.4455 14.7487 17.4069 14.8939 17.3357 15.0238C17.2645 15.1538 17.1629 15.2645 17.0396 15.3465C16.9162 15.4286 16.7748 15.4796 16.6275 15.495L16.5317 15.5H3.46833C3.32013 15.5001 3.17413 15.4642 3.04285 15.3954C2.91156 15.3267 2.79889 15.2271 2.71451 15.1053C2.63013 14.9835 2.57654 14.843 2.55833 14.6959C2.54013 14.5489 2.55786 14.3996 2.61 14.2609L2.64833 14.1734L4.16666 11.1367V8.00002C4.16666 6.45292 4.78124 4.96919 5.87521 3.87523C6.96917 2.78127 8.4529 2.16669 10 2.16669Z",
    fill: "white",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1618_290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.017ad8af6aa5c053b5bbba456f0549e4.svg";
export { ForwardRef as ReactComponent };